import script from "./MarkerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkerTab.vue?vue&type=script&setup=true&lang=js"

import "./MarkerTab.vue?vue&type=style&index=0&id=544ea274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-544ea274"]])

export default __exports__